export const audienceConstants = {
  AUDIENCE_LOAD: '[Audience] Load',
  AUDIENCE_LOAD_SUCCESS: '[Audience] Load success',
  AUDIENCE_LOAD_FAILURE: '[Audience] Load failure',
  AUDIENCE_RESET: '[Audience] Reset',
  AUDIENCE_SAVE: '[Audience] Save',
  AUDIENCE_SAVE_SUCCESS: '[Audience] Save success',
  AUDIENCE_SAVE_FAILURE: '[Audience] Save failure',
  AUDIENCE_DELETE: '[Audience] Delete',
  AUDIENCE_DELETE_SUCCESS: '[Audience] Delete success',
  AUDIENCE_DELETE_FAILURE: '[Audience] Delete failure'
}
